import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Card, CardTitle, CardBody, FormGroup, Label, Input, Button, CustomInput, Form, } from "reactstrap";
import Select from 'react-select';
import { Countries, States } from "../../../common/data/constants"
import Category from "pages/Setup/Category";
import "react-datepicker/dist/react-datepicker.css";
import { Formik, useFormik } from 'formik';
import * as Yup from 'yup';
import {
  fetchCategories,
  fetchDepartments,
  fetchDesignations,
  fetchShiftGroups,
  fetchShifts,
  createEmployee,
  fetchEmployeeTabWiseInfo,
  getShiftGroupDetails
} from "store/actions";
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { FiSave } from "react-icons/fi";
import nv5 from "../../../assets/images/brands/b-nav-5.png";
import CustomDatePicker from "common/CustomDatePicker";

const OrganizationalDetails = ({ empID,formikRef, dropdownData,isActive,triggerKey,onCategoryChange }) => {
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const { blood_groups, country, state, empment_type, reporting_to, document_type, week_off, salary_through, shift_change, employee_nature,salary_type } = dropdownData;
  const {
    categories,
    departments,
    designations,
    shiftGroups,
    shiftDetails,
    employeeOrgInfo = [],
    loading,
    error,
  } = useSelector((state) => ({
    categories: state.CategoryMaster?.categories ?? [],
    departments: state.DepartmentMaster?.departments ?? [],
    designations: state.DesignationMaster?.designations ?? [],
    shiftGroups: state.shiftGroupReducer?.shiftGroups ?? [],
    shiftDetails: state.EmployeeDetailsReducer?.shiftDetails ?? [],

    employeeOrgInfo: empID == 0 ? [] : state.EmployeeDetailsReducer?.employeeTabData?.organization || [],
    
    loading: state.CategoryMaster?.loading || state.DepartmentMaster?.loading || state.DesignationMaster?.loading || state.shiftGroupReducer?.loading || state.shiftReducer?.loading || state.employeeReducer?.loading,
    error: state.CategoryMaster?.error || state.DepartmentMaster?.error || state.DesignationMaster?.error || state.shiftGroupReducer?.error || state.shiftReducer?.error || state.employeeReducer?.error,
  }));
  const [initialGroupLoaded, setInitialGroupLoaded] = useState(false);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchCategories(unitId));
    dispatch(fetchDepartments(unitId));
    dispatch(fetchDesignations(unitId));
    dispatch(fetchShiftGroups(unitId));
    dispatch(fetchShifts(unitId));
  }, [dispatch]);

  useEffect(() => {
      if (!empID) return;

      if (isActive) {
        console.log("🔥 Fetching Organization Details - Trigger");
        dispatch(fetchEmployeeTabWiseInfo(empID, "organization"));
      }
    }, [isActive, empID, triggerKey]);   // 👈 Added


  const formik = useFormik({
    initialValues: {
      category: '',
      department: '',
      designation: '',
      doj: '',
      audit: '',
      employeeType: '',
      employeeNature: '',
      reportingTo: '',
      salaryThrough: '',
      salaryType: '',
      attendanceNotRequired: false,
      markerAutoApproval: false,
      eliminateApprovalWorkflow: false,
      pfNotEligible: false,
      esiNotEligible: false,
      salaryProcessedByHourlyWages: false,
      weekOff: [],
      shiftGroup: "",
      shift: "",
      shiftChange: "",
      dataUpdateByEmployee: false,
      physicallyChallenged: false,
      weekoffEligibility: false,
      extraDutyEligibility: false,
      shiftLateEligibility: false,
      permissionEligibility: false,
      incentiveEligibility: false,
      earnedLeaveEligibility: false,
      punchBasedShiftUpdate: false,
      mobileUser: false,
      mobilepunch: false
    },
    validationSchema: Yup.object({
      category: Yup.object().required('Category is required'),
      department: Yup.object().required('Department is required'),
      designation: Yup.object().required('Designation is required'),
      doj: Yup.date().nullable().required('Date of Joining is required'),
      audit: Yup.date().nullable(),
      employeeType: Yup.object().required('Employee Type is required'),
      employeeNature: Yup.object().required('Employee Nature is required'),
      reportingTo: Yup.object().required('Reporting To is required'),
      shiftGroup: Yup.object().required('Shift Group is required'),
      shift: Yup.object().required('Shift is required'),
      shiftChange: Yup.object().required('Shift Change is required'),
      weekOff: Yup.array().min(1, 'Select week off').required('Week Off is required'),
    }),
    onSubmit: async (values) => {
      if (values.empId === 0) {
        if (!formikRef.current) {
          alert("OrganizationalDetails form is not available.");
          return;
        }
    
        // Validate OrganizationalDetails Form
        const isValid = await formikRef.current.validateForm();
        if (Object.keys(isValid).length > 0) {
          alert("Please fill all required fields in Organizational Details.");
          return;
        }
    
        // // Get OrganizationalDetails Values
        // const orgValues = formikRef.current.values;
        
        // // Dispatch values to update EmployeePersonal
        // dispatch(updateEmployeePersonal(orgValues));
      }else{
        const payload = {
          emp: [
            {
              emp_id:empID,
              cat_id: values.category?.value || "", 
              category: values.category?.label || "",
              dept_id: values.department?.value || "",
              department: values.department?.label || "",
              desig_id: values.designation?.value || "",
              desination: values.designation?.label || "",
              doj: values.doj ? values.doj : "",
              audit_doj: values.audit ? values.audit : "",
              emp_type: values.employeeType?.value || "",
              emp_nature: values.employeeNature?.value || "",
              reporting_id: values.reportingTo?.value || "",
              reporting: values.reportingTo?.label || "",
              salary_through: values.salaryThrough?.value || "0",
              wage_type: values.salaryType?.value || "0",
              att_not_required: values.attendanceNotRequired ? "1" : "0",
              auto_approval: values.markerAutoApproval ? "1" : "0",
              eliminate_app_workflow: values.eliminateApprovalWorkflow ? "1" : "0",
              pf_not_eligible: values.pfNotEligible ? "1" : "0",
              esi_not_eligible: values.esiNotEligible ? "1" : "0",
              hourly_wages:values.salaryProcessedByHourlyWages ? "1" : "0",
              shift_change: values.shiftChange?.value || "",
              data_update_emp: values.dataUpdateByEmployee ? "1" : "0",
              physically_challenged: values.physicallyChallenged ? "1" : "0",
              is_extra_eli: values.weekoffEligibility ? "1" : "0",
              is_extra_duty: values.extraDutyEligibility ? "1" : "0",
              is_shift_late: values.shiftLateEligibility ? "1" : "0",
              is_permission: values.permissionEligibility ? "1" : "0",
              is_incentive: values.incentiveEligibility ? "1" : "0",
              punch_based_shift: values.punchBasedShiftUpdate ? "1" : "0",
              is_cl: values.earnedLeaveEligibility ? "1" : "0",
              is_el: values.earnedLeaveEligibility ? "1" : "0",
              is_mobusr: values.mobileUser ? "1" : "0",
              is_mobpunch: values.mobilepunch ? "1" : "0",
              create_by: authDetails.user_id,
              shift_grp_id : values.shiftGroup?.value,
              shift_id : values.shift?.value,
              week_off: values.weekOff?.map(item => item.value).join(",") || "",
              unit_id:authDetails?.unit_id
            }
          ]
        };

        const formData = new FormData();
        formData.append("lst_employee_personnel", JSON.stringify(payload));
        formData.append("create_by", authDetails.user_id);
        dispatch(createEmployee(formData,'organization'));
      }
      formik.resetForm()
    }
  });

  useEffect(() => {
    if (employeeOrgInfo.length > 0) {
      const emp = employeeOrgInfo[0];
      const employeeType = (empment_type || []).find(empType => empType.emptype_id.toString() === String(emp.emp_type)) || null;
      const employeeNature = (employee_nature || []).find(nature => nature.emp_natureid.toString() === String(emp.emp_nature)) || null;
      const reportingTo = (reporting_to || []).find(report => report.report_id.toString() === String(emp.reporting_id)) || null;
      const salaryThrough = (salary_through || []).find(salary => salary.salary_throughid.toString() === String(emp.salary_through)) || null;
      const salaryType = (salary_type || []).find(salary => salary.wage_typeid.toString() === String(emp.wage_type)) || null;

      // const shift = (shiftDetails || []).find(report => report.shift_id.toString() === String(emp.shift_id)) || null;
      const shiftGroup = (shiftGroups || []).find(salary => salary.groupid.toString() === String(emp.shift_grp_id)) || null;
      const shiftchange = (shift_change || []).find(salary => salary.week_id.toString() === String(emp.shift_change)) || null;
      
      const weekIds = emp.week_off ? emp.week_off.split(",") : [];
      const weekOff = (week_off || [])
        .filter(salary => weekIds.includes(String(salary.week_id)))
        .map(salary => ({
          value: String(salary.week_id),
          label: salary.week_off
        }));

      formik.setValues({

        category: { value: emp.cat_id, label: emp.category },
        designation: { value: emp.desig_id, label: emp.desination },
        department: { value: emp.dept_id, label: emp.department },
        employeeType: employeeType
          ? { value: employeeType.emptype_id, label: employeeType.emp_type }
          : null,

        employeeNature: employeeNature
          ? { value: employeeNature.emp_natureid, label: employeeNature.emp_nature }
          : null,

        reportingTo: reportingTo
          ? { value: reportingTo.report_id, label: reportingTo.report_name }
          : null,

        salaryThrough: salaryThrough
          ? { value: salaryThrough.salary_throughid, label: salaryThrough.salary_through }
          : null,

        salaryType: salaryType
          ? { value: salaryType.wage_typeid, label: salaryType.wage_type }
          : null,
  
        doj: emp.doj ? emp.doj : null,
        audit: emp.audit_doj ? emp.audit_doj : null,
  
        attendanceNotRequired: Boolean(emp.att_not_required),
        eliminateApprovalWorkflow: Boolean(emp.eliminate_app_workflow),
        pfNotEligible: Boolean(emp.pf_not_eligible),
        esiNotEligible: Boolean(emp.esi_not_eligible),
        physicallyChallenged: Boolean(emp.physically_challenged),
        markerAutoApproval: Boolean(emp.auto_approval),
        salaryProcessedByHourlyWages: Boolean(emp.hourly_wages),
        weekOff: weekOff,

        shiftGroup: shiftGroup
          ? { value: shiftGroup.groupid, label: shiftGroup.groupName }
          : null,
        // shift: shift
        // ? { value: shift.shift_id, label: shift.shift_name }
        // : null,
        shiftChange: shiftchange
        ? { value: shiftchange.week_id, label: shiftchange.week_off }
        : null,

        dataUpdateByEmployee: Boolean(emp.data_update_emp),
        weekoffEligibility: Boolean(emp.is_extra_eli),
        extraDutyEligibility: Boolean(emp.is_extra_duty),
        shiftLateEligibility: Boolean(emp.is_shift_late),
        permissionEligibility: Boolean(emp.is_permission),
        incentiveEligibility: Boolean(emp.is_incentive),
        earnedLeaveEligibility: Boolean(emp.is_el),
        punchBasedShiftUpdate: Boolean(emp.punch_based_shift),
        mobileUser: Boolean(emp.is_mobusr),
        mobilepunch: Boolean(emp.is_mobilepunch),
      });
    }
  }, [employeeOrgInfo, categories, departments, designations, empment_type, employee_nature, reporting_to, salary_through, salary_type]);
  
  useEffect(() => {
    if (shiftDetails?.length > 0 && employeeOrgInfo?.[0]?.shift_id) {
      const emp = employeeOrgInfo[0];
      const matchedShift = shiftDetails.find(
        s => s.shift_id.toString() === String(emp.shift_id)
      );

      if (matchedShift) {
        formik.setFieldValue("shift", {
          value: matchedShift.shift_id,
          label: matchedShift.shift_name
        });
      }
    }
  }, [shiftDetails, employeeOrgInfo]);

  useEffect(() => {
    if (formikRef) {
      formikRef.current = formik;
    }
  }, [formik, formikRef]);

  // select custome style
  const SelectcustomStyles = {
    control: (base) => ({
      ...base,
      maxheight: 33.1,
      minHeight: 33.1,
      // overflow: "scroll",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      padding: "0", // Match the padding for both dropdown and clear indicator
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Ensure consistent padding for dropdown indicator
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Adjust padding for clear indicator to match dropdown
    }),
  };

  // useEffect(() => {
  //     if(isActive){
  //       dispatch(fetchEmployeeTabWiseInfo(empID,'organization'));
  //     }
  // }, [dispatch,isActive]);

    // useEffect(() => {
    //   if (dropdownData && Object.keys(dropdownData).length > 0 && isActive) {
    //         const timeoutId = setTimeout(() => {
    //             dispatch(fetchEmployeeTabWiseInfo(empID, 'organization'));
    //         }, 500);
  
    //         return () => clearTimeout(timeoutId);
    //     }
    // }, [dispatch, dropdownData, isActive]);

  const handleShiftGroupChange = (selectedOption) => {
    // Set new group
    formik.setFieldValue("shiftGroup", selectedOption);

    // ❌ Clear any previously selected shift
    formik.setFieldValue("shift", null);

    // Fetch new shift group details
    if (selectedOption?.value) {
      dispatch(getShiftGroupDetails(authDetails?.unit_id, selectedOption.value));
    }
  };

  useEffect(() => {
  if (formik.values.shiftGroup?.value) {
    const selectedGroup = shiftGroups.find(
      (g) => g.groupid == formik.values.shiftGroup?.value
    );

    if (selectedGroup) {
      formik.setFieldValue("shiftGroup", {
        value: selectedGroup.groupid,
        label: selectedGroup.groupName,
      });

      dispatch(getShiftGroupDetails(authDetails?.unit_id, selectedGroup.groupid));
    }
  }
}, [shiftGroups,formik.values.shiftGroup?.value]);

  useEffect(() => {
    if (
      isActive &&
      employeeOrgInfo &&
      employeeOrgInfo.length > 0 &&
      !initialGroupLoaded &&
      authDetails?.unit_id
    ) {
      const selectedGroup = formik.values?.shiftGroup;
      if (selectedGroup?.value) {
        dispatch(getShiftGroupDetails(authDetails?.unit_id, selectedGroup.value));
        setInitialGroupLoaded(true); // ✅ Mark as done
      }
    }
  }, [
    isActive,
    employeeOrgInfo,
    formik.values?.shiftGroup?.value,
    authDetails?.unit_id,
    dispatch,
    initialGroupLoaded,
  ]);

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Card>
        <div className="card-main-title">
          <h6 className="title">
            <img src={nv5} className="img-fluid w-auto h-auto" alt="img" />
            Organizational Information
          </h6>
        </div>
        <CardBody className="per-info">
          <Row>
            <Col md={4} className="mb-3">
              <FormGroup>
                <Label for="category">Category <span className="text-danger">*</span></Label>
                <Select
                  styles={SelectcustomStyles}
                  id="category"
                  name="category"
                  // options={categoryData}
                  // value={categoryData.find(option => option.value === formik.values.category)}
                  // onChange={(option) => formik.setFieldValue("category", option)}
                  // onBlur={() => formik.setFieldTouched("category", true)}
                  options={categories.map(cat => ({ value: cat.empCatgryid.toString(), label: cat.empCategory }))}
                  value={formik.values.category || null}  // Store full object
                 // onChange={(selectedOption) => formik.setFieldValue("category", selectedOption)}
                 onChange={(selectedOption) => {
                    formik.setFieldValue("category", selectedOption)
                    if (onCategoryChange) {
                      onCategoryChange(selectedOption);
                    }
                  }}

                  onBlur={formik.handleBlur}
                  className={`${formik.touched.category && formik.errors.category ? "is-invalid" : ""} hrms-select`}
                  classNamePrefix="hrms-select"
                />
                {formik.touched.category && formik.errors.category && (
                  <div className="text-danger">{formik.errors.category}</div>
                )}
              </FormGroup>
            </Col>

            {/* Designation */}
            <Col md={4} className="mb-3">
              <FormGroup>
                <Label for="designation"> Designation (Job Title) <span className="text-danger">*</span></Label>
                <Select
                  styles={SelectcustomStyles}
                  id="designation"
                  name="designation"
                  // options={[{ value: "Desig1", label: "Desig1" }, { value: "Desig2", label: "Desig2" }]}
                  // value={[{ value: "Desig1", label: "Desig1" }, { value: "Desig2", label: "Desig2" }].find(
                  //   option => option.value === formik.values.designation
                  // )}
                  // onChange={(option) => formik.setFieldValue("designation", option)}
                  // onBlur={() => formik.setFieldTouched("designation", true)}
                  options={designations.map(cat => ({ value: cat.desig_id.toString(), label: cat.designation }))}
                  value={formik.values.designation || null}  // Store full object
                  onChange={(selectedOption) => formik.setFieldValue("designation", selectedOption)}
                  className={`${formik.touched.designation && formik.errors.designation ? "is-invalid" : ""} hrms-select`}
                  classNamePrefix="hrms-select"
                />
                {formik.touched.designation && formik.errors.designation && (
                  <div className="text-danger">{formik.errors.designation}</div>
                )}
              </FormGroup>
            </Col>

            {/* Department */}
            <Col md={4} className="mb-3">
              <FormGroup>
                <Label for="department">Department <span className="text-danger">*</span></Label>
                <Select
                  styles={SelectcustomStyles}
                  id="department"
                  name="department"
                  // options={departmentData}
                  // value={departmentData.find(option => option.value === formik.values.department)}
                  // onChange={(option) => formik.setFieldValue("department", option)}
                  // onBlur={() => formik.setFieldTouched("department", true)}
                  options={departments.map(cat => ({ value: cat.departmentId.toString(), label: cat.departmentname }))}
                  value={formik.values.department || null}  // Store full object
                  onChange={(selectedOption) => formik.setFieldValue("department", selectedOption)}
                  onBlur={formik.handleBlur}
                  className={`${formik.touched.department && formik.errors.department ? "is-invalid" : ""} hrms-select`}
                  classNamePrefix="hrms-select"
                />
                {formik.touched.department && formik.errors.department && (
                  <div className="text-danger">{formik.errors.department}</div>
                )}
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label for="doj">DOJ <span className="text-danger">*</span></Label>
                <Row>
                  <Col className="col-12">
                    {/* <Input
                      type="date"
                      id="doj"
                      name="doj"
                      className="form-control"
                      value={formik.values.doj}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    /> */}
                    <CustomDatePicker
                      name="doj"
                      value={formik.values.doj}
                      onChange={(date) => formik.setFieldValue("doj", date)}
                      // onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={`${`form-control ${formik.touched.doj && formik.errors.doj ? "is-invalid" : ""}`} hrms-select`}
                      classNamePrefix="hrms-select"
                      // disableFuture={true}
                    />
                    {formik.touched.doj && formik.errors.doj ? (
                      <div className="text-danger">{formik.errors.doj}</div>
                    ) : null}
                  </Col>
                  {/* <Col md={6}>
                    <Input
                      type="date"
                      id="audit"
                      name="audit"
                      className="form-control"
                      value={formik.values.audit}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.audit && formik.errors.audit ? (
                      <div className="text-danger">{formik.errors.audit}</div>
                    ) : null}
                  </Col> */}
                </Row>
              </FormGroup>
            </Col>

            <Col md={4}>
              <FormGroup>
                <Label for="audit">
                  Audit DOJ
                </Label>

                <CustomDatePicker
                  name="audit"
                  value={formik.values.audit}
                  onChange={(date) => formik.setFieldValue("audit", date)}
                  onBlur={formik.handleBlur}
                  className={`${`form-control ${formik.touched.audit && formik.errors.audit ? "is-invalid" : ""}`} hrms-select`}
                  classNamePrefix="hrms-select"
                />

                {formik.touched.audit && formik.errors.audit ? (
                  <div className="text-danger">{formik.errors.audit}</div>
                ) : null}
              </FormGroup>
            </Col>


            {/* Employee Type Select */}
            <Col md={4} className="mb-3">
              <FormGroup>
                <Label for="employeeType">Employee Type <span className="text-danger">*</span></Label>
                <Select
                  styles={SelectcustomStyles}
                  id="employeeType"
                  name="employeeType"
                  // options={employeeTypeData}
                  // value={formik.values.employeeType} // Fix: Ensure value is set
                  // onChange={(option) => formik.setFieldValue("employeeType", option)}
                  // onBlur={() => formik.setFieldTouched("employeeType", true)}
                  options={(empment_type || []).map(cat => ({ value: cat.emptype_id.toString(), label: cat.emp_type }))}
                  value={formik.values.employeeType || null}  // Store full object
                  onChange={(selectedOption) => formik.setFieldValue("employeeType", selectedOption)}
                  onBlur={formik.handleBlur}
                  className={`${formik.touched.employeeType && formik.errors.employeeType ? "is-invalid" : ""} hrms-select`}
                  classNamePrefix="hrms-select"
                />
                {formik.touched.employeeType && formik.errors.employeeType && (
                  <div className="text-danger">{formik.errors.employeeType}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={4} className="mb-3">
              <FormGroup>
                <Label for="employeeNature">Employee Nature <span className="text-danger">*</span></Label>
                <Select
                  styles={SelectcustomStyles}
                  id="employeeNature"
                  name="employeeNature"
                  // options={employeeNatureOptions}
                  // value={formik.values.employeeNature} // Fix: Ensure value is set
                  // onChange={(option) => formik.setFieldValue("employeeNature", option)}
                  // onBlur={() => formik.setFieldTouched("employeeNature", true)}
                  options={(employee_nature || []).map(cat => ({ value: cat.emp_natureid.toString(), label: cat.emp_nature }))}
                  value={formik.values.employeeNature || null}  // Store full object
                  onChange={(selectedOption) => formik.setFieldValue("employeeNature", selectedOption)}
                  onBlur={formik.handleBlur}
                  className={`${formik.touched.employeeNature && formik.errors.employeeNature ? "is-invalid" : ""} hrms-select`}
                  classNamePrefix="hrms-select"
                />
                {formik.touched.employeeNature && formik.errors.employeeNature && (
                  <div className="text-danger">{formik.errors.employeeNature}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={4} className="mb-3">
              <FormGroup>
                <Label for="reportingTo">Reporting To <span className="text-danger">*</span></Label>
                <Select
                  styles={SelectcustomStyles}
                  id="reportingTo"
                  name="reportingTo"
                  // options={reportingTo}
                  // value={formik.values.reportingTo} // Fix: Ensure value is set
                  // onChange={(option) => formik.setFieldValue("reportingTo", option)}
                  // onBlur={() => formik.setFieldTouched("reportingTo", true)}
                  options={(reporting_to || []).map(cat => ({ value: cat.report_id.toString(), label: cat.report_name }))}
                  value={formik.values.reportingTo || null}  // Store full object
                  onChange={(selectedOption) => formik.setFieldValue("reportingTo", selectedOption)}
                  onBlur={formik.handleBlur}
                  className={`${formik.touched.reportingTo && formik.errors.reportingTo ? "is-invalid" : ""} hrms-select`}
                  classNamePrefix="hrms-select"
                />
                {formik.touched.reportingTo && formik.errors.reportingTo && (
                  <div className="text-danger">{formik.errors.reportingTo}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={4} className="mb-3">
              <FormGroup>
                <Label for="salaryThrough">Salary Through</Label>
                <Select
                  styles={SelectcustomStyles}
                  id="salaryThrough"
                  name="salaryThrough"
                  // options={salaryThrough}
                  // value={formik.values.salaryThrough} // Fix: Ensure value is set
                  // onChange={(option) => formik.setFieldValue("salaryThrough", option)}
                  // onBlur={() => formik.setFieldTouched("salaryThrough", true)}
                  options={(salary_through || []).map(cat => ({ value: cat.salary_throughid.toString(), label: cat.salary_through }))}
                  value={formik.values.salaryThrough || null}  // Store full object
                  onChange={(selectedOption) => formik.setFieldValue("salaryThrough", selectedOption)}
                  onBlur={formik.handleBlur}
                  className={`${formik.touched.salaryThrough && formik.errors.salaryThrough ? "is-invalid" : ""} hrms-select`}
                  classNamePrefix="hrms-select"
                />
                {formik.touched.salaryThrough && formik.errors.salaryThrough && (
                  <div className="text-danger">{formik.errors.salaryThrough}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={4} className="mb-3">
              <FormGroup>
                <Label for="salaryType">Salary Type</Label>
                <Select
                  styles={SelectcustomStyles}
                  id="salaryType"
                  name="salaryType"
                  // options={salaryType}
                  // value={formik.values.salaryType} // Fix: Ensure value is set
                  // onChange={(option) => formik.setFieldValue("salaryType", option)}
                  // onBlur={() => formik.setFieldTouched("salaryType", true)}
                  options={(salary_type || []).map(cat => ({ value: cat.wage_typeid.toString(), label: cat.wage_type }))}
                  value={formik.values.salaryType || null}  // Store full object
                  onChange={(selectedOption) => formik.setFieldValue("salaryType", selectedOption)}
                  onBlur={formik.handleBlur}
                  className={`${formik.touched.salaryType && formik.errors.salaryType ? "is-invalid" : ""} hrms-select`}
                  classNamePrefix="hrms-select"
                />
                {formik.touched.salaryType && formik.errors.salaryType && (
                  <div className="text-danger">{formik.errors.salaryType}</div>
                )}
              </FormGroup>
            </Col>

            {/* Shift Group Select */}
            <Col md={4} className="mb-3">
              <FormGroup>
                <Label for="shiftGroup">Shift Group <span className="text-danger">*</span></Label>
                {/* <Select
                  styles={SelectcustomStyles}
                  id="shiftGroup"
                  name="shiftGroup"
                  // options={shiftGroup}
                  // value={formik.values.shiftGroup} // Fix: Ensure value is set
                  // onChange={(option) => formik.setFieldValue("shiftGroup", option)}
                  // onBlur={() => formik.setFieldTouched("shiftGroup", true)}
                  options={(shiftGroups || []).map(cat => ({ value: cat.groupid.toString(), label: cat.groupName }))}
                  value={formik.values.shiftGroup || null}  // Store full object
                  // onChange={(selectedOption) => formik.setFieldValue("shiftGroup", selectedOption)}
                  onChange={handleShiftGroupChange}
                  onBlur={formik.handleBlur}
                  className={`${formik.touched.shiftGroup && formik.errors.shiftGroup ? "is-invalid" : ""} hrms-select`}
                  classNamePrefix="hrms-select"
                /> */}
                <Select
                  styles={SelectcustomStyles}
                  id="shiftGroup"
                  name="shiftGroup"
                  options={(shiftGroups || []).map(g => ({
                    value: g.groupid,
                    label: g.groupName
                  }))}

                  value={formik.values.shiftGroup}

                  onChange={(option) => handleShiftGroupChange(option)}
                  
                  onBlur={() => formik.setFieldTouched("shiftGroup", true)}
                  className={`${formik.touched.shiftGroup && formik.errors.shiftGroup ? "is-invalid" : ""} hrms-select`}
                  classNamePrefix="hrms-select"
                />

                {formik.touched.shiftGroup && formik.errors.shiftGroup && (
                  <div className="text-danger">{formik.errors.shiftGroup}</div>
                )}
              </FormGroup>
            </Col>

            {/* Shift Select */}
            <Col md={4} className="mb-3">
              <FormGroup>
                <Label for="shift">Shift <span className="text-danger">*</span></Label>
                {/* <Select
                  styles={SelectcustomStyles}
                  id="shift"
                  name="shift"
                  // options={shift}
                  // value={formik.values.shift} // Fix: Ensure value is set
                  // onChange={(option) => formik.setFieldValue("shift", option)}
                  // onBlur={() => formik.setFieldTouched("shift", true)}
                  options={(shiftDetails || []).map(cat => ({ value: cat.shift_id.toString(), label: cat.shift_name }))}
                  value={formik.values.shift || null}  // Store full object
                  onChange={(selectedOption) => formik.setFieldValue("shift", selectedOption)}
                  onBlur={formik.handleBlur}
                  className={`${formik.touched.shift && formik.errors.shift ? "is-invalid" : ""} hrms-select`}
                  classNamePrefix="hrms-select"
                /> */}
                <Select
                  styles={SelectcustomStyles}
                  id="shift"
                  name="shift"
                  options={(shiftDetails || []).map(s => ({
                    value: s.shift_id,
                    label: s.shift_name
                  }))}
                  
                  value={formik.values.shift}

                  onChange={(option) => formik.setFieldValue("shift", option)}

                  onBlur={() => formik.setFieldTouched("shift", true)}
                  className={`${formik.touched.shift && formik.errors.shift ? "is-invalid" : ""} hrms-select`}
                  classNamePrefix="hrms-select"
                />

                {formik.touched.shift && formik.errors.shift && (
                  <div className="text-danger">{formik.errors.shift}</div>
                )}
              </FormGroup>
            </Col>

            {/* Shift Change Select */}
            <Col md={4} className="mb-3">
              <FormGroup>
                <Label for="shiftChange">Shift Change <span className="text-danger">*</span></Label>
                <Select
                  styles={SelectcustomStyles}
                  id="shiftChange"
                  name="shiftChange"
                  // options={shiftChange}
                  // value={formik.values.shiftChange} // Fix: Ensure value is set
                  // onChange={(option) => formik.setFieldValue("shiftChange", option)}
                  // onBlur={() => formik.setFieldTouched("shiftChange", true)}
                  options={(shift_change || []).map(cat => ({ value: cat.week_id.toString(), label: cat.week_off }))}
                  value={formik.values.shiftChange || null}  // Store full object
                  onChange={(selectedOption) => formik.setFieldValue("shiftChange", selectedOption)}
                  onBlur={formik.handleBlur}
                  className={`${formik.touched.shiftChange && formik.errors.shiftChange ? "is-invalid" : ""} hrms-select`}
                  classNamePrefix="hrms-select"
                />
                {formik.touched.shiftChange && formik.errors.shiftChange && (
                  <div className="text-danger">{formik.errors.shiftChange}</div>
                )}
              </FormGroup>
            </Col>

            <Col md={4} className="mb-3">
              <FormGroup>
                <Label for="weekOff">Week Off <span className="text-danger">*</span></Label>
                <Select
                  styles={SelectcustomStyles}
                  id="weekOff"
                  name="weekOff"
                  // options={weekOff}
                  options={(week_off || []).map(cat => ({ value: cat.week_id.toString(), label: cat.week_off }))}
                  value={formik.values.weekOff || null}  // Store full object
                  onChange={(selectedOption) => formik.setFieldValue("weekOff", selectedOption)}
                  onBlur={formik.handleBlur}
                  isMulti
                  className={`${formik.touched.weekOff && formik.errors.weekOff ? "is-invalid" : ""} hrms-select`}
                  classNamePrefix="hrms-select"
                  />
                  {formik.touched.weekOff && formik.errors.weekOff && (
                    <div className="text-danger">{formik.errors.weekOff}</div>
                  )}
              </FormGroup>
            </Col>

            {/* <Col md={12} className="mb-3">
            <FormGroup>
              <Label for="dataUpdateByEmployee" className="mb-0 d-flex align-items-center">
                <Input
                  type="checkbox"
                  id="dataUpdateByEmployee"
                  className="me-2" // Bootstrap margin-end utility
                  onChange={formik.handleChange}
                  checked={formik.values.dataUpdateByEmployee}
                />
                Data Update by Employee
              </Label>
            </FormGroup>
          </Col> */}

            {/* <Col className="col-12">
              <h6 className="mb-3">Eligibility Details</h6>
              <Row className="chk-lst">
                <Col md={4} className="mb-3 d-flex align-items-center">
              <FormGroup className="d-flex align-items-center">
                <Label for="attendanceNotRequired" className="mb-0 d-flex align-items-center">
                  <Input
                    type="checkbox"
                    id="attendanceNotRequired"
                    className="me-2" // Bootstrap margin-end utility
                    onChange={formik.handleChange}
                    checked={formik.values.attendanceNotRequired}
                  />
                  Attendance Not Required
                </Label>
              </FormGroup>
            </Col>
            <Col md={4} className="mb-3 d-flex align-items-center">
              <FormGroup className="d-flex align-items-center">
                <Label for="markerAutoApproval" className="mb-0 d-flex align-items-center">
                  <Input
                    type="checkbox"
                    id="markerAutoApproval"
                    className="me-2" // Bootstrap margin-end utility
                    onChange={formik.handleChange}
                    checked={formik.values.markerAutoApproval}
                  />
                  Marker Auto Approval
                </Label>
              </FormGroup>
            </Col>
            <Col md={4} className="mb-3 d-flex align-items-center">
              <FormGroup className="d-flex align-items-center">
                <Label for="eliminateApprovalWorkflow" className="mb-0 d-flex align-items-center">
                  <Input
                    type="checkbox"
                    id="eliminateApprovalWorkflow"
                    className="me-2" // Bootstrap margin-end utility
                    onChange={formik.handleChange}
                    checked={formik.values.eliminateApprovalWorkflow}
                  />
                  Eliminate Approval Workflow
                </Label>
              </FormGroup>
            </Col>
            <Col md={4} className="mb-3 d-flex align-items-center">
              <FormGroup className="d-flex align-items-center">
                <Label for="pfNotEligible" className="mb-0 d-flex align-items-center">
                  <Input
                    type="checkbox"
                    id="pfNotEligible"
                    className="me-2" // Bootstrap margin-end utility
                    onChange={formik.handleChange}
                    checked={formik.values.pfNotEligible}
                  />
                  PF Not Eligible
                </Label>
              </FormGroup>
            </Col>
            <Col md={4} className="mb-3 d-flex align-items-center">
              <FormGroup className="d-flex align-items-center">
                <Label for="esiNotEligible" className="mb-0 d-flex align-items-center">
                  <Input
                    type="checkbox"
                    id="esiNotEligible"
                    className="me-2" // Bootstrap margin-end utility
                    onChange={formik.handleChange}
                    checked={formik.values.esiNotEligible}
                  />
                  ESI Not Eligible
                </Label>
              </FormGroup>
            </Col>
            <Col md={4} className="mb-3 d-flex align-items-center">
              <FormGroup className="d-flex align-items-center">
                <Label for="salaryProcessedByHourlyWages" className="mb-0 d-flex align-items-center">
                  <Input
                    type="checkbox"
                    id="salaryProcessedByHourlyWages"
                    className="me-2" // Bootstrap margin-end utility
                    onChange={formik.handleChange}
                    checked={formik.values.salaryProcessedByHourlyWages}
                  />
                  Salary Processed by Hourly Wages
                </Label>
              </FormGroup>
            </Col>
                <Col md={4} className="d-flex align-items-center">
                  <FormGroup className="d-flex align-items-center">
                    <Label for="weekoffEligibility">
                      <Input
                        type="checkbox"
                        id="weekoffEligibility"
                        className="me-2"
                        onChange={formik.handleChange}
                        checked={formik.values.weekoffEligibility}
                      />
                      Weekoff
                    </Label>
                  </FormGroup>
                </Col>
                <Col md={4} className="d-flex align-items-center">
                  <FormGroup className="d-flex align-items-center">
                    <Label for="extraDutyEligibility">
                      <Input
                        type="checkbox"
                        id="extraDutyEligibility"
                        className="me-2"
                        onChange={formik.handleChange}
                        checked={formik.values.extraDutyEligibility}
                      />
                      Extra Duty
                    </Label>
                  </FormGroup>
                </Col>
                <Col md={4} className="d-flex align-items-center">
                  <FormGroup className="d-flex align-items-center">
                    <Label for="shiftLateEligibility">
                      <Input
                        type="checkbox"
                        id="shiftLateEligibility"
                        className="me-2"
                        onChange={formik.handleChange}
                        checked={formik.values.shiftLateEligibility}
                      />
                      Shift Late
                    </Label>
                  </FormGroup>
                </Col>
                <Col md={4} className="d-flex align-items-center">
                  <FormGroup className="d-flex align-items-center">
                    <Label for="permissionEligibility">
                      <Input
                        type="checkbox"
                        id="permissionEligibility"
                        className="me-2"
                        onChange={formik.handleChange}
                        checked={formik.values.permissionEligibility}
                      />
                      Permission
                    </Label>
                  </FormGroup>
                </Col>
                <Col md={4} className="d-flex align-items-center">
                  <FormGroup className="d-flex align-items-center">
                    <Label for="incentiveEligibility">
                      <Input
                        type="checkbox"
                        id="incentiveEligibility"
                        className="me-2"
                        onChange={formik.handleChange}
                        checked={formik.values.incentiveEligibility}
                      />
                      Incentive
                    </Label>
                  </FormGroup>
                </Col>
                <Col md={4} className="d-flex align-items-center">
                  <FormGroup className="d-flex align-items-center">
                    <Label for="earnedLeaveEligibility">
                      <Input
                        type="checkbox"
                        id="earnedLeaveEligibility"
                        className="me-2"
                        onChange={formik.handleChange}
                        checked={formik.values.earnedLeaveEligibility}
                      />
                      Earned Leave
                    </Label>
                  </FormGroup>
                </Col>
                <Col md={4} className="d-flex align-items-center">
                  <FormGroup className="d-flex align-items-center">
                    <Label for="punchBasedShiftUpdate">
                      <Input
                        type="checkbox"
                        id="punchBasedShiftUpdate"
                        className="me-2"
                        onChange={formik.handleChange}
                        checked={formik.values.punchBasedShiftUpdate}
                      />
                      Punch Based Shift Update
                    </Label>
                  </FormGroup>
                </Col>
                <Col md={4} className="d-flex align-items-center">
                  <FormGroup className="d-flex align-items-center">
                    <Label for="mobileUser">
                      <Input
                        type="checkbox"
                        id="mobileUser"
                        className="me-2"
                        onChange={formik.handleChange}
                        checked={formik.values.mobileUser}
                      />
                      Mobile User
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
            </Col> */}
            <Col className="col-12">
  <h6 className="mb-3">Eligibility Details</h6>
  <Row className="chk-lst">

    {/* Attendance Not Required */}
    <Col md={4} className="mb-3 d-flex align-items-center">
      <FormGroup className="d-flex align-items-center">
        <Label for="attendanceNotRequired" className="mb-0 d-flex align-items-center">
          <Input type="checkbox" id="attendanceNotRequired" className="me-2"
            checked={formik.values.attendanceNotRequired}
            onChange={formik.handleChange}
          />
          Attendance Not Required
        </Label>
      </FormGroup>
    </Col>
    <Col md={4} className="mb-3 d-flex align-items-center">
  <FormGroup className="d-flex align-items-center">
    <Label for="dataUpdateByEmployee" className="mb-0 d-flex align-items-center">
      <Input
        type="checkbox"
        id="dataUpdateByEmployee"
        className="me-2"
        checked={formik.values.dataUpdateByEmployee}
        onChange={formik.handleChange}
      />
      Data Update by Employee
    </Label>
  </FormGroup>
</Col>

    {/* Earned Leave */}
    <Col md={4} className="mb-3 d-flex align-items-center">
      <FormGroup className="d-flex align-items-center">
        <Label for="earnedLeaveEligibility" className="mb-0 d-flex align-items-center">
          <Input type="checkbox" id="earnedLeaveEligibility" className="me-2"
            checked={formik.values.earnedLeaveEligibility}
            onChange={formik.handleChange}
          />
          Earned Leave
        </Label>
      </FormGroup>
    </Col>

    {/* Eliminate Approval Workflow */}
    <Col md={4} className="mb-3 d-flex align-items-center">
      <FormGroup className="d-flex align-items-center">
        <Label for="eliminateApprovalWorkflow" className="mb-0 d-flex align-items-center">
          <Input type="checkbox" id="eliminateApprovalWorkflow" className="me-2"
            checked={formik.values.eliminateApprovalWorkflow}
            onChange={formik.handleChange}
          />
          Eliminate Approval Workflow
        </Label>
      </FormGroup>
    </Col>

    {/* ESI Not Eligible */}
    <Col md={4} className="mb-3 d-flex align-items-center">
      <FormGroup className="d-flex align-items-center">
        <Label for="esiNotEligible" className="mb-0 d-flex align-items-center">
          <Input type="checkbox" id="esiNotEligible" className="me-2"
            checked={formik.values.esiNotEligible}
            onChange={formik.handleChange}
          />
          ESI Not Applicable
        </Label>
      </FormGroup>
    </Col>

    {/* Extra Duty */}
    <Col md={4} className="mb-3 d-flex align-items-center">
      <FormGroup className="d-flex align-items-center">
        <Label for="extraDutyEligibility" className="mb-0 d-flex align-items-center">
          <Input type="checkbox" id="extraDutyEligibility" className="me-2"
            checked={formik.values.extraDutyEligibility}
            onChange={formik.handleChange}
          />
          Extra Duty
        </Label>
      </FormGroup>
    </Col>

    {/* Incentive */}
    <Col md={4} className="mb-3 d-flex align-items-center">
      <FormGroup className="d-flex align-items-center">
        <Label for="incentiveEligibility" className="mb-0 d-flex align-items-center">
          <Input type="checkbox" id="incentiveEligibility" className="me-2"
            checked={formik.values.incentiveEligibility}
            onChange={formik.handleChange}
          />
          Incentive
        </Label>
      </FormGroup>
    </Col>

    {/* Marker Auto Approval */}
    <Col md={4} className="mb-3 d-flex align-items-center">
      <FormGroup className="d-flex align-items-center">
        <Label for="markerAutoApproval" className="mb-0 d-flex align-items-center">
          <Input type="checkbox" id="markerAutoApproval" className="me-2"
            checked={formik.values.markerAutoApproval}
            onChange={formik.handleChange}
          />
          Marker Auto Approval
        </Label>
      </FormGroup>
    </Col>
   
    {/* PF Not Eligible */}
    <Col md={4} className="mb-3 d-flex align-items-center">
      <FormGroup className="d-flex align-items-center">
        <Label for="pfNotEligible" className="mb-0 d-flex align-items-center">
          <Input type="checkbox" id="pfNotEligible" className="me-2"
            checked={formik.values.pfNotEligible}
            onChange={formik.handleChange}
          />
          PF Not Applicable
        </Label>
      </FormGroup>
    </Col>

    {/* Permission */}
    <Col md={4} className="mb-3 d-flex align-items-center">
      <FormGroup className="d-flex align-items-center">
        <Label for="permissionEligibility" className="mb-0 d-flex align-items-center">
          <Input type="checkbox" id="permissionEligibility" className="me-2"
            checked={formik.values.permissionEligibility}
            onChange={formik.handleChange}
          />
          Permission
        </Label>
      </FormGroup>
    </Col>
    <Col md={4} className="mb-3 d-flex align-items-center">
  <FormGroup className="d-flex align-items-center">
    <Label for="physicallyChallenged" className="mb-0 d-flex align-items-center">
      <Input
        type="checkbox"
        id="physicallyChallenged"
        className="me-2"
        checked={formik.values.physicallyChallenged}
        onChange={formik.handleChange}
      />
      Physically Challenged
    </Label>
  </FormGroup>
</Col>
 

    {/* Punch Based Shift Update */}
    <Col md={4} className="mb-3 d-flex align-items-center">
      <FormGroup className="d-flex align-items-center">
        <Label for="punchBasedShiftUpdate" className="mb-0 d-flex align-items-center">
          <Input type="checkbox" id="punchBasedShiftUpdate" className="me-2"
            checked={formik.values.punchBasedShiftUpdate}
            onChange={formik.handleChange}
          />
          Punch Based Shift Update
        </Label>
      </FormGroup>
    </Col>

    {/* Salary Processed by Hourly Wages */}
    <Col md={4} className="mb-3 d-flex align-items-center">
      <FormGroup className="d-flex align-items-center">
        <Label for="salaryProcessedByHourlyWages" className="mb-0 d-flex align-items-center">
          <Input type="checkbox" id="salaryProcessedByHourlyWages" className="me-2"
            checked={formik.values.salaryProcessedByHourlyWages}
            onChange={formik.handleChange}
          />
          Salary Processed by Hourly Wages
        </Label>
      </FormGroup>
    </Col>

    {/* Shift Late */}
    <Col md={4} className="mb-3 d-flex align-items-center">
      <FormGroup className="d-flex align-items-center">
        <Label for="shiftLateEligibility" className="mb-0 d-flex align-items-center">
          <Input type="checkbox" id="shiftLateEligibility" className="me-2"
            checked={formik.values.shiftLateEligibility}
            onChange={formik.handleChange}
          />
          Shift Late
        </Label>
      </FormGroup>
    </Col>

    {/* Weekoff */}
    <Col md={4} className="mb-3 d-flex align-items-center">
      <FormGroup className="d-flex align-items-center">
        <Label for="weekoffEligibility" className="mb-0 d-flex align-items-center">
          <Input type="checkbox" id="weekoffEligibility" className="me-2"
            checked={formik.values.weekoffEligibility}
            onChange={formik.handleChange}
          />
          Weekoff
        </Label>
      </FormGroup>
    </Col>
     {/* Mobile User */}
    <Col md={4} className="mb-3 d-flex align-items-center">
      <FormGroup className="d-flex align-items-center">
        <Label for="mobileUser" className="mb-0 d-flex align-items-center">
          <Input type="checkbox" id="mobileUser" className="me-2"
            checked={formik.values.mobileUser}
            onChange={formik.handleChange}
          />
          Mobile User
        </Label>
      </FormGroup>
    </Col>
     {/* Punch User */}
    <Col md={4} className="mb-3 d-flex align-items-center">
      <FormGroup className="d-flex align-items-center">
        <Label for="mobilepunch" className="mb-0 d-flex align-items-center">
          <Input type="checkbox" id="mobilepunch" className="me-2"
            checked={formik.values.mobilepunch}
            onChange={formik.handleChange}
          />
          Mobile Punch
        </Label>
      </FormGroup>
    </Col>
  </Row>
</Col>

          </Row>
          {empID > 0 && (
            <Row className="row-sm">
              <Col className="d-flex justify-content-end align-items-center">
                <button type="submit" className="btn button-save d-flex align-items-center gap-2">
                  <i className="fas fa-save " /> Save & Continue
                </button>
              </Col>
            </Row>
          )}
        </CardBody>
      </Card>
    </Form>
  );
};

export default OrganizationalDetails;
